import type { RuntimeSessionResponse } from "@/features/deployment-selection/model/runtime-session";
import { platformHttpClient } from "@/shared/api/platform-http-client";

/**
 * Request a runtime session (short-lived runtime API access token and target URL)
 * for a deployment, scoped to the given operations.
 *
 * See `docs/api/endpoints.md` (situate-platform-api) for the full contract.
 */
export function fetchRuntimeSession(
  deploymentId: string,
  operationIds: string[],
  ttlSeconds?: number
): Promise<RuntimeSessionResponse> {
  return platformHttpClient.post<RuntimeSessionResponse>(
    `/v1/deployments/${encodeURIComponent(deploymentId)}/runtime-session`,
    {
      operations: operationIds.map((operation_id) => ({ operation_id })),
      ...(ttlSeconds !== undefined && { ttl_seconds: ttlSeconds }),
    }
  );
}
